export default function useField(
  name: string,
  label: string,
  { rules = 'required', component='d-control-simple-input', ...rest } = {}
) {
  return { name, label, rules, component, ...rest }
}